import { useEffect } from 'react';

// keysConfig - object where key is fieild and value - color
// Example: { id: '#DF7000', name: '#4287f5', age: '#42f554' }
function useColorJsonKeys(keysConfig = {}) {
  useEffect(() => {
    const colorizeKeyValues = () => {
      const rows = document.querySelectorAll('.variable-row');

      rows.forEach(row => {
        const keyElement = row.querySelector('.object-key');
        if (keyElement) {
          const keyText = keyElement.textContent.replace(/"/g, '').trim();

          if (keysConfig[keyText]) {
            // Ищем элемент значения - берем первый div внутри .variable-value
            const valueElement = row.querySelector('.variable-value > div');

            if (valueElement) {
              valueElement.style.color = keysConfig[keyText];
            }
          }
        }
      });
    };

    colorizeKeyValues();
  }, [keysConfig]);
}

export default useColorJsonKeys;

// react-json-view theme. Colored tokens (strings/numbers/null) stay constant,
// while neutral text and punctuation adapt to the active app theme so the JSON
// stays readable on both light and dark backgrounds.
export const getJsonViewTheme = (isDark = false) => {
  const text = isDark ? '#FFFFFF' : '#27272A';
  const muted = isDark ? '#A1A1AA' : '#7A7A83';

  return {
    base00: 'transparent',
    base01: muted,
    base02: 'transparent',
    base03: muted,
    base04: muted,
    base05: text, // text color
    base06: muted,
    base07: muted,
    base08: muted,
    base09: '#35BD29', // strings
    base0A: '#D71313', // null
    base0B: text, // keys
    base0C: muted,
    base0D: 'transparent', // icon collapse
    base0E: muted, // false & icon collapsed
    base0F: '#D71313', // numbers
  };
};
